import { Component } from '@angular/core';

@Component({
  selector: 'cf-storybook-shell-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {}
